module.exports = __webpack_public_path__ + "img/ico_menual02_on.ac19c5ca.svg";